import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ChatService from 'walden-fast/services/chat';

export default class AppContactChatRoute extends Route {
  @service('chat') declare chat: ChatService;

  beforeModel() {
    this.chat.initialFetch();
  }
}
